export default __webpack_public_path__ + "static/media/025-roundabout.9ba22352.png";